import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { User, UserListParams } from '~/features/user/types/user.type';

/**
 * 사용자 목록 조회
 * @description 등록된 사용자 목록을 조회합니다
 * @endpoint GET /admin/users
 * @param params - 조회 파라미터
 * @returns 사용자 목록 및 페이지네이션 정보
 */
export function getUserListApi(params?: UserListParams) {
  return axiosInstance.get<PaginatedApiResponse<User>>('/admin/users', { params });
}
